import { parse } from "uuid";
import { supabase } from "../../../app/supabaseClient";
import neo4jApi from "../supabaseSlice";

const classifiedsApi = neo4jApi.injectEndpoints({
  endpoints: (build) => ({
    getClassifieds: build.query({
      queryFn: async ({ search: { category_id, location_id }, limit }) => {
        let listingsQuery = supabase
          .from("categories")
          .select(
            `*, classifieds(*,
            locations(*),
            amenities:classified_amenity(amenity:amenities(*)),
            facilities:classified_facility(quantity,facility:facilities(*)))`
          )
          .in("classifieds.status", ["approved"]) // U
          .limit(limit, {
            foreignTable: 'classifieds',
            foreignKey: 'category_id',
          })
          .order("created_at", { ascending: false, referencedTable: 'classifieds' });


        const { data: listings, error } = await listingsQuery
          .order("order")

        console.log("listings", listings);



        if (error) throw error;
        return { data: listings };
      },
    }),
    getPinnedClassifieds: build.query({
      queryFn: async (categoryId) => {
        const { data, error } = await supabase
          .from("ads")
          .select(
            `*,
            classified:classifieds(*,
            locations(*),
            amenities:classified_amenity(amenity:amenities(*)),
            facilities:classified_facility(quantity,facility:facilities(*))
            )`
          )
          .in("classified.status", ["approved"])
          .eq("type", "pinned_to_top")
          .eq("classified.category_id", categoryId)
          .eq("date", new Date().toISOString().slice(0, 10));
        if (error) throw { error };

        const classifieds = data
          .filter((ad) => ad.classified)
          .map((ad) => ad.classified);

        classifieds.forEach((classified) => {
          classified.featured = true;
          return classified;
        });

        const response = classifieds;
        return { data: response };
      },
    }),
    getClassified: build.query({
      queryFn: async (id) => {
        const { data, error } = await supabase
          .from("classifieds")
          .select(
            `*,
            locations(*),
          amenities:classified_amenity(amenity:amenities(*)),
          facilities:classified_facility(quantity,facility:facilities(*)),
          categories(*, 
            similars: classifieds(
              *,locations(*),
              amenities:classified_amenity(amenity:amenities(*)),
              facilities:classified_facility(quantity,facility:facilities(*))
            )
          )
          `
          )
          .eq("id", id)
          .not('categories.similars.id', 'in', `(${id})`)
          .order("created_at", { ascending: false, referencedTable: 'categories.similars' })
          .limit(9, {
            referencedTable: 'categories.similars',
          })
          .single();
        if (error) throw { error };
        return { data };
      },
    }),
    getClassifiedByCategory: build.query({
      queryFn: async ({
        categoryId,
        page,
        search: { filter, location_id },
      }) => {
        let countQuery = supabase
          .from("classifieds")
          .select("*", { count: "exact", head: true })
          .eq("category_id", categoryId)
          .in("status", ["approved"])
        if (location_id && location_id != -1) {
          countQuery = countQuery.eq("location_id", location_id);
        }

        if (filter) {
          countQuery = countQuery.ilike("title", `%${filter}%`);
        }

        const { count: countClassified } = await countQuery;

        // const { data: pinnedAds, error: pinnedError } = await
        let pinnedAdsQuery = supabase
          .from("ads")
          .select(
            `*,
            classified:classifieds(*,
            locations(*),
            amenities:classified_amenity(amenity:amenities(*)),
            facilities:classified_facility(quantity,facility:facilities(*))
            )`
          )
          .in("classified.status", ["approved"])
          .eq("type", "pinned_to_top")
          .eq("classified.category_id", categoryId)
          .eq("date", new Date().toISOString().slice(0, 10));

        if (location_id && location_id != -1) {
          pinnedAdsQuery = pinnedAdsQuery.eq(
            "classified.location_id",
            location_id
          );
        }

        if (filter) {
          pinnedAdsQuery = pinnedAdsQuery.ilike(
            "classified.title",
            `%${filter}%`
          );
        }

        const { data: pinnedAds, error: pinnedError } = await pinnedAdsQuery;

        const pinnedClassified = pinnedAds
          .filter((ad) => ad.classified)
          .map((ad) => ad.classified);

        pinnedClassified.forEach((classified) => {
          classified.featured = true;
          return classified;
        });

        if (pinnedError) throw { pinnedError };

        if (pinnedClassified.length > page * 42) {
          return {
            data: {
              classified: pinnedClassified,
              count: countClassified,
            },
          };
        }

        console.log(pinnedClassified)

        console.log(page);
        // 15 /9 = 1
        page = page - Math.floor(pinnedClassified.length / 42);

        console.log(page);

        const from =
          page > 1 ? (page - 1) * 42 - (pinnedClassified.length % 42) : 0;
        const to = page * 42 - (pinnedClassified.length % 42) - 1;

        console.log(from, to);
        let listingsQuery = supabase
          .from("classifieds")
          .select(
            `*,
          locations(*),
          amenities:classified_amenity(amenity:amenities(*)),
          facilities:classified_facility(quantity,facility:facilities(*))`
          )
          .eq("category_id", categoryId)
          .in("status", ["approved"])
          .not(
            "id",
            "in",
            `(${pinnedClassified.map((classified) => classified.id)})`
          );
        if (location_id && location_id != -1) {
          listingsQuery = listingsQuery.eq("location_id", location_id);
        }

        if (filter) {
          listingsQuery = listingsQuery.ilike("title", `%${filter}%`);
        }

        const { data, error } = await listingsQuery
          .range(from, to)
          .order("created_at", { ascending: false });

        if (error) throw { error };
        data.forEach((classified) => {
          return classified;
        });
        let response = [];
        if (pinnedClassified.length > (page - 1) * 42) {
          response = [...pinnedClassified, ...data];
        } else {
          response = data;
        }
        return {
          data: { classified: response, count: countClassified },
        };
      },
    }),
    getClassifiedByUser: build.query({
      queryFn: async () => {
        const {
          data: { user },
        } = await supabase.auth.getUser();
        console.log(user.id);
        const { data, error } = await supabase
          .from("classifieds")
          .select(
            `*,
          amenities:classified_amenity(amenity:amenities(*)),
          facilities:classified_facility(quantity,facility:facilities(*))`
          )
          .in("status", ["approved", "pending", "draft", "expired"])
          .eq("created_by", user.id)
          .order("created_at", { ascending: false });
        if (error) throw { error };
        const response = data;
        return { data: response };
      },
    }),
    createClassified: build.mutation({
      queryFn: async ({
        classified,
        classifiedProperties,
        amenities,
        facilities,
      }) => {
        const {
          data: { user },
        } = await supabase.auth.getUser();
        console.log("classified", classified);
        const { data, error } = await supabase
          .from("classifieds")
          .insert({
            ...classified,
            created_by: user.id,
            properties: classifiedProperties,
          })
          .select()
          .single();
        if (error) throw { error };
        if (amenities && amenities.length > 0) {
          amenities.forEach(async (amenityId) => {
            await supabase
              .from("classified_amenity")
              .upsert({ classified_id: data.id, amenity_id: amenityId });
          });
        }
        if (facilities && facilities.length > 0) {
          facilities.forEach(async (facility) => {
            await supabase.from("classified_facility").upsert({
              classified_id: data.id,
              facility_id: facility.id,
              quantity: facility.quantity,
            });
          });
        }

        return { data };
      },
    }),
    updateClassified: build.mutation({
      queryFn: async ({
        classified,
        classifiedProperties,
        amenities,
        facilities,
      }) => {
        const classified_id = parseInt(classified.id);
        console.log(classified.status);
        const {
          data: { user },
        } = await supabase.auth.getUser();
        const { data, error } = await supabase
          .from("classifieds")
          .upsert({
            ...classified,
            created_by: user.id,
            properties: classifiedProperties,
          })
          .select()
          .eq("id", classified_id)
          .eq("created_by", user.id)
          .single();
        if (error) throw { error };

        if (amenities.length > 0) {
          // Delete existing amenities
          await supabase
            .from("classified_amenity")
            .delete()
            .eq("classified_id", classified_id);
          amenities.forEach(async (amenityId) => {
            await supabase
              .from("classified_amenity")
              .upsert({ classified_id, amenity_id: amenityId });
          });
        }
        if (facilities.length > 0) {
          // Delete existing facilities
          await supabase
            .from("classified_facility")
            .delete()
            .eq("classified_id", classified_id);
          facilities.forEach(async (facility) => {
            await supabase.from("classified_facility").upsert({
              classified_id,
              facility_id: facility.id,
              quantity: facility.quantity,
            });
          });
        }

        return { data };
      },
    }),
    deleteClassifiedByUser: build.mutation({
      queryFn: async (id) => {
        const {
          data: { user },
        } = await supabase.auth.getUser();
        const { data, error } = await supabase
          .from("classifieds")
          .update({ status: "deleted" })
          .eq("id", id)
          .eq("created_by", user.id);

        if (error) throw { error };
        return { data };
      },
    }),
    getImpressionClassified: build.query({
      queryFn: async (id) => {
        const { data, error } = await supabase
          .from("classified_impression")
          .select()
          .eq("classified_id", id);
        if (error) throw { error };
        return { data };
      },
    }),
    viewImpressionClassified: build.mutation({
      queryFn: async (id) => {
        // add view count
        const date = new Date();
        const { data: classified } = await supabase
          .from("classified_impression")
          .select()
          .eq("classified_id", id)
          .eq("date", date.toISOString().slice(0, 10))
          .single();
        if (classified) {
          const { data, error } = await supabase
            .from("classified_impression")
            .upsert({
              classified_id: id,
              view_count: classified.view_count + 1,
              date: date.toISOString().slice(0, 10),
            })
            .select();
          if (error) throw { error };
        } else {
          const { data, error } = await supabase
            .from("classified_impression")
            .upsert({
              classified_id: id,
              view_count: 1,
              click_count: 0,
              date: date.toISOString().slice(0, 10),
            })
            .select();
          if (error) throw { error };
        }
        return { success: true };
      },
    }),
    clickImpressionClassified: build.mutation({
      queryFn: async (id) => {
        // add click count
        const date = new Date();
        const { data: classified } = await supabase
          .from("classified_impression")
          .select()
          .eq("classified_id", id)
          .eq("date", date.toISOString().slice(0, 10))
          .single();
        if (classified) {
          const { data, error } = await supabase
            .from("classified_impression")
            .upsert({
              classified_id: id,
              click_count: classified.click_count + 1,
              date: date.toISOString().slice(0, 10),
            })
            .select();
          if (error) throw { error };
        } else {
          const { data, error } = await supabase
            .from("classified_impression")
            .upsert({
              classified_id: id,
              view_count: 0,
              click_count: 1,
              date: date.toISOString().slice(0, 10),
            })
            .select();
          if (error) throw { error };
        }
      },
    }),
    deleteClassified: build.mutation({
      queryFn: async (id) => {
        console.log("delete", id);
        const { data, error } = await supabase
          .from("classifieds")
          .update({ status: "deleted" })
          .eq("id", id);
        if (error) throw { error };
        return { data };
      },
    }),
  }),
});

export const {
  useGetClassifiedsQuery,
  useGetClassifiedQuery,
  useLazyGetClassifiedQuery,
  useGetClassifiedByUserQuery,
  useGetClassifiedByCategoryQuery,
  useCreateClassifiedMutation,
  useDeleteClassifiedMutation,
  useDeleteClassifiedByUserMutation,
  useViewImpressionClassifiedMutation,
  useUpdateClassifiedMutation,
  useGetImpressionClassifiedQuery,
  useGetPinnedClassifiedsQuery,
} = classifiedsApi;
